// frontend/src/components/DifferencesComponent/index.js
import DifferencesComponent from './DifferencesComponent';

export default DifferencesComponent;
